(() => {
  function closeDialog(dialog) { if (dialog?.open) dialog.close(); }
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-open-dialog]');
    if (open) {
      const dialog = document.getElementById(open.dataset.openDialog);
      if (dialog && !dialog.open) {dialog.showModal();dialog.querySelector('input')?.focus();}
    }
    const close = event.target.closest('[data-close-dialog]');
    if (close) closeDialog(close.closest('dialog'));
    if (event.target.tagName === 'DIALOG') {
      const r=event.target.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeDialog(event.target);
    }
    const zoom = event.target.closest('[data-image-zoom]');
    if (zoom) {
      const dialog=document.getElementById('ProductZoom');
      const image=document.getElementById('ZoomImage');
      if(dialog&&image){image.src=zoom.dataset.imageZoom;image.alt=zoom.dataset.imageAlt||'Product image';dialog.showModal();}
    }
  });
  document.addEventListener('change',(event)=>{
    if(!event.target.matches('[data-variant-select]'))return;
    const area=event.target.closest('[data-product-section]');
    const option=event.target.selectedOptions[0];
    const available=option.dataset.available==='true';
    area.querySelector('[data-product-price]').textContent=option.dataset.price;
    const button=area.querySelector('[data-add-button]');button.disabled=!available;button.textContent=available?'ADD TO BAG':'SOLD OUT';
    const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
  });
})();
